import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Table } from 'reactstrap';
import Skeleton from 'react-loading-skeleton';
import Actions from '../../../Actions';
import Paginate from '../Layout/Paginate';
import LocationRow from './LocationRow';
import LocationAdd from './Add';
import Edit from './Edit';
import Filter from '../Layout/Filter';
import Tile from '../Layout/Tile';
import SubLocationsModal from './SubLocations/Modal';

class LocationList extends Component {
    componentDidMount = () => {
        const { auth, getLocations } = this.props;
        getLocations(auth.token, {page: 1, order: "asc", sort: "name" }, false);
    }

    showSubLocations = (id) => {
        const { locations, toggleModal, setModalData } = this.props;
        if(locations.hasOwnProperty(id)){
            setModalData("subLocations","display",{id});
            toggleModal("subLocations","display");
        }
    }

    edit = (id) => {
        const { locations, toggleModal, setModalData } = this.props;
        if(locations.hasOwnProperty(id)){
            setModalData("locations","edit",locations[id]);
            toggleModal("locations","edit");
        }
    }

    locationsLoading = () => {
        const data = [];
        for(let i=0;i<10;i++){
            data.push(
                <Tile key={i+"-loading"} xs="12" style={{padding: "1vh 1vw"}} className="mx-auto">
                    <Skeleton count={4}/>
                </Tile>
            );
        }

        return data;
    }

    locations = () => {
        const { locations, locationsMeta } = this.props;
        const rows = [];
        const { data = [] } = locationsMeta;
        data.map((id) => {
            rows.push(
                <LocationRow key={id} showSubLocations={this.showSubLocations} edit={this.edit} location={locations[id]}/>
            );
        });
        return rows;
    }

    render(){
        const { getLocations, locationsLoading, locationsMeta, query } = this.props;
        return (
            <div style={{ padding: "3px"}}>        
               {locationsLoading ? this.locationsLoading():
                <Row>
                    <Col lg="5" md="6" xs="12">
                        <Table responsive className="text-left">
                            <thead>
                                <tr>
                                    <th className="text-nowrap">
                                        <Filter query={query} id="name" title="Location" field="name" filter={getLocations} />
                                    </th>
                                    <th>
                                        Sub Locations
                                    </th>
                                    <th>
                                        Delete
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.locations()}
                            </tbody>
                        </Table>
                        <Paginate fetch={getLocations} meta={locationsMeta}  />
                        <Edit />
                        <LocationAdd />
                        <SubLocationsModal />
                    </Col>
                </Row>
               }
            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    auth: state.auth,
    locations: state.locationStore.locations,
    locationsMeta: state.locationStore.locationsMeta,
    query: state.locationStore.query,
    locationsLoading: state.locationStore.locationsLoading,
});

const { locations, modals } = Actions;

export default connect(mapStateToProps,{ ...locations, ...modals })(LocationList);


// WEBPACK FOOTER //
// ./src/Components/App/Locations/LocationList.js